import React, { ReactNode } from 'react';
import CardListESchool from '../CardListESchool';
import CalendarEventViewItemESchool, {
  Event,
} from '../CalendarEventViewItemESchool';
import CalendarIcon from './images/calendar.svg';

export type CalendarCardListProps = {
  title?: string;
  viewAll?: ReactNode;
  height?: string;
  loading?: boolean;
  fallback?: ReactNode;
  events: Event[];
  headerIcon?: string;
  onItemClick?: (item: any) => void;
};

const TCalendarCardList: React.FC<CalendarCardListProps> = ({
  title,
  viewAll,
  events = [],
  loading = false,
  height,
  fallback,
  headerIcon,
  onItemClick = () => {},
}) => {
  return (
    <CardListESchool
      title={title}
      viewAll={viewAll}
      loading={loading}
      height={height}
      fallback={fallback}
      headerIcon={headerIcon || CalendarIcon}
    >
      {!!events.length
        ? events.map((item, index) => (
            <CalendarEventViewItemESchool
              key={index}
              {...item}
              onItemClick={() => {
                onItemClick(item);
              }}
            />
          ))
        : null}
    </CardListESchool>
  );
};

export default TCalendarCardList;
